/**
 * Handle post-navigation tasks after route changes
 * @param {Object} to - The target route object from Vue Router
 */
export function handleRouteAfterEach(to) {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg');
  if (appLoading) {
    appLoading.style.display = 'none';
  }

  // Update page title
  document.title = to.meta.pageTitle || 'Fresh Clinics';

  // Hide HubSpot chat on specific routes
  const isComplianceRoute = to && to.path && /^\/(nurse|org-owner|basic)\/compliance(\/|$)/.test(to.path);
  const isProductRoute = to && to.path && /^\/(nurse|org-owner|basic|doctor)\/product(\/|$)/.test(to.path);
  const shouldHideChat = isComplianceRoute || isProductRoute;
  const body = document.body;

  if (body) {
    // Remove any left positioning class and apply hide on compliance
    body.classList.remove('left-hubspot-chat');
    body.classList.toggle('hide-hubspot-chat', !!shouldHideChat);

    // Toggle mobile-only hide for hubspot chat when viewport is small
    const isMobile = window.matchMedia && window.matchMedia('(max-width: 640px)').matches;
    const shouldHideOnMobile = isMobile && shouldHideChat;
    body.classList.toggle('mobile-hide-hubspot-chat', shouldHideOnMobile);
  }
}

